<div (click)="useQuickFilter.emit()"
     class="card">
    <div class="card-title">
        <img class="title-icon"
             [ngClass]="{'borderless': hasLargeIcon}"
             [src]="asset">
        <span [i18n]="labelKey"
              class="title-label"></span>
    </div>

    <div class="card-count">
        <span>{{ count }}</span>
    </div>

</div>
